export enum SublimeCompanyType {

    SUBLIME_ACCOUNTING = "SUBLIME_ACCOUNTING",
    SUBLIME_PAYROLL_SERVICES = "SUBLIME_PAYROLL_SERVICES",
    SUBLIME_CONSULTING = "SUBLIME_CONSULTING",
    SUBLIME_PROJECTS = "SUBLIME_PROJECTS",

}
